import * as React from 'react';

import * as styles from './SearchTipsContainer.css';
import { SearchTip } from '../../components/SearchTips/SearchTip';
import { IFullTipSchema } from '../../repositories/text-search/entities/tips/FullTipSchema';
import classNames from 'classnames';
import { Responsive } from '@cian/ui-kit';
import { useTipsContext } from './provider';

interface ISearchTipsContainerProps {
  desktopStyle?: boolean;
  isMainPageTips?: boolean;
  onClick: (tips: IFullTipSchema) => void;
}

export const SearchTipsContainer: React.FC<ISearchTipsContainerProps> = ({
  desktopStyle = false,
  isMainPageTips = false,
  onClick,
}) => {
  const { mainTips, searchTips, mobileTips, isTipsDisabled, handleMainTipClick } = useTipsContext();

  const tipsToRender = isMainPageTips ? mainTips : searchTips;

  if (
    (desktopStyle && (!tipsToRender || !tipsToRender.length)) ||
    (!desktopStyle && (!mobileTips || !mobileTips.length))
  ) {
    return null;
  }

  return (
    <div>
      <Responsive desktop>
        <div
          className={classNames(
            styles['gallery-container'],
            isMainPageTips && styles['main-page-style'],
            desktopStyle && styles['desktop-style'],
          )}
        >
          {tipsToRender.map((tip, index) => (
            <SearchTip
              key={index}
              tip={tip}
              onClick={isMainPageTips ? handleMainTipClick : onClick}
              isTipsDisabled={isTipsDisabled}
            />
          ))}
        </div>
      </Responsive>

      <Responsive phone tablet>
        <div className={classNames(styles['wrap-container'])}>
          {mobileTips.map((tip, index) => (
            <SearchTip key={index} tip={tip} onClick={onClick} />
          ))}
        </div>
      </Responsive>
    </div>
  );
};
